import { ContactsService, InitContactDialogInput } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type ContactsContactDialogsEmailInput = {
  dialogId: number;
  formData?: {
    Subject: string;
    Body: string;
    Attachments?: Array<Blob>;
  };
};

export const useContactsDialogsEmailMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof ContactsService.postContactsContactDialogsEmail>>,
      QueryError,
      ContactsContactDialogsEmailInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ dialogId, formData }: ContactsContactDialogsEmailInput) =>
      ContactsService.postContactsContactDialogsEmail(dialogId, formData),
    {
      ...options,
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
